import type { FC, PropsWithChildren } from 'react';
import { createContext, useContext, useMemo, useState } from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

interface Context {
  isShown: boolean;
  close: () => void;
  update: (newState: boolean) => void;
}

const DropdownContext = createContext<Context | null>(null);

export const DropdownContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isShown, setIsShown] = useState<boolean>(false);

  const close = useCallbackRef(() => {
    setIsShown(false);
  });

  const update = useCallbackRef((value: boolean) => {
    setIsShown(value);
  });

  const value = useMemo<Context>(() => ({ isShown, close, update }), [isShown, close, update]);

  return <DropdownContext.Provider value={value}>{children}</DropdownContext.Provider>;
};

export const useDropdownContext = () => {
  const ctx = useContext(DropdownContext);

  if (!ctx) {
    throw new Error('useDropdownContext must be used within DropdownContextProvider');
  }

  return ctx;
};
